import React from "react";

export default function Graph_Plotly() {
  return (
    <div>
      <h1>Graph_Plotly</h1>
      <p>This is the Graph_Plotly component.</p>
    </div>
  );
}
